import React from 'react';
import { motion } from 'framer-motion';
import { Cloud } from 'lucide-react';

const TOP_CLOUDS = Array.from({ length: 5 }, (_, i) => ({
  animate: { x: [0, 40, 0], y: [0, -25, 0] },
  transition: { duration: 10 + i * 2, repeat: Infinity, ease: 'easeInOut', delay: i * 1.5 },
  style: { top: `${15 + i * 18}%`, left: `${5 + i * 20}%` },
}));

const BOTTOM_CLOUDS = Array.from({ length: 4 }, (_, i) => ({
  animate: { x: [0, 30, 0], scale: [1, 1.1, 1] },
  transition: { duration: 7 + i, repeat: Infinity, ease: 'easeInOut', delay: i * 0.5 },
}));

export const TopClouds = () => (
  <div className="absolute inset-0 pointer-events-none">
    {TOP_CLOUDS.map((cfg, i) => (
      <motion.div key={`cloud-top-${i}`} animate={cfg.animate} transition={cfg.transition} className="absolute" style={cfg.style}>
        <Cloud className="w-20 h-20 md:w-32 md:h-32 lg:w-40 lg:h-40 text-white/20" fill="white" />
      </motion.div>
    ))}
  </div>
);

export const BottomClouds = () => (
  <div className="absolute bottom-[-50px] left-0 right-0 flex justify-around pointer-events-none">
    {BOTTOM_CLOUDS.map((cfg, i) => (
      <motion.div key={`cloud-bottom-${i}`} animate={cfg.animate} transition={cfg.transition}>
        <Cloud className="w-28 h-28 md:w-40 md:h-40 lg:w-48 lg:h-48 text-white/30" fill="white" />
      </motion.div>
    ))}
  </div>
);
